export default __webpack_public_path__ + "static/media/absa-secondary.3f14f384.png";